<script lang="ts">
      import { browser } from '$app/environment'
      import { formatDate, getLocaleDay } from '$lib/utils/date'
      import { ResultSync } from '$lib/utils/result'
      import { getLocaleContext } from '../locale/ts/Locale.svelte'
      import MenuArrow from '../menu/MenuArrow.svelte'
      import BlockHeading from '../ui/BlockHeading.svelte'
      import FilterPill from './Program/FilterPill.svelte'
      import HeadingPill from './Program/HeadingPill.svelte'
      import ProgramListItem from './ProgramListItem.svelte'

      let { items } = $props()

      let locale = getLocaleContext()

      let wrapper: HTMLElement

      function recursiveKey(input: any, key: string) {
            let output = input
            const keys = key.split('.')
            for (let i = 0; i < keys.length; i++) {
                  output = output[keys[i]]
            }

            return output
      }

      let filters = $state([
            {
                  key: 'catalogue.type',
                  value: undefined as any,
                  fn: (item: any[], value: string) => item.find((i) => String(i.id) === value),
                  prepFn: (value: any) => ({ value: value.id, label: value.type, key: 'catalogue.type', index: value.filterIndex }),
                  exclude: new Set()
            },
            {
                  key: 'catalogue.tags',
                  value: undefined as any,
                  fn: (item: any[], value: string) => item.find((i) => String(i.id) === value),
                  prepFn: (value: any) => ({ value: value.id, label: value.tag, key: 'catalogue.tags', index: value.filterIndex }),
                  exclude: new Set(),
            },
            //{
            //      key: 'catalogue.program',
            //      value: undefined as any,
            //      prepFn: (value: any) => ({ value: value, label: value, key: 'catalogue.program' }),
            //      fn: (item: any, value: string) => item == value,
            //},
      ])

      function filterFunction(items: any[], filterArray: any[]) {
            let input = items
            for (let i = 0; i < filterArray.length; i++) {
                  const filter = filterArray[i]
                  if (!filter.value) continue
                  input = input.filter((item) => {
                        let { value } = ResultSync(() => recursiveKey(item, filter.key))
                        if (!value) return false
                        const res = filter.fn(value, filter.value)
                        return !!res
                  })
            }
            return input
      }

      type FilterValue = {
            value: any
            key: string
            label: string
            index: number
      }

      function setFilter(ev: Event) {
            const target = ev.currentTarget as HTMLElement | undefined
            if (!target) return
            const value = target.getAttribute('data-filter-value')
            const key = target.getAttribute('data-filter-key')
            if (!key || !value) return

            filters.forEach((f) => {
                  f.value = undefined
                  if (f.key == key) f.value = value
            })

            //console.log(filters)
      }

      function resetFilter() {
            filters.forEach((f) => {
                  f.value = undefined
            })
      }

      let filterActive = $derived.by(() => {
            return !!filters.find((f) => !!f.value)
      })

      let filterValues = $derived.by(() => {
            const keys = filters.map((f) => ({ key: f.key, values: [] as FilterValue[], filter: f }))

            items.forEach((item: any) => {
                  keys.forEach((key, i) => {
                        let value = recursiveKey(item, key.key)
                        if (!value) return
                        if (!Array.isArray(value)) value = [value]
                        if (value.length == 0) return
                        value.forEach((_value: any) => {
                              if( _value.excludeFromFilters ) return
                              if (key.filter.prepFn) _value = key.filter.prepFn(_value)
                              if (key.filter.exclude?.has(_value.value)) return
                              const exits = key.values.find((v) => _value.value == v.value)
                              if (!exits) key.values.push(_value)
                        })
                  })
            })

            return keys.map((f) => f.values).flat().sort( (a,b) => {
              //console.log(a,b)
              const _a = a.index ?? 99
              const _b = b.index ?? 99
              return  _a - _b
            })
      })

      let _items = $derived.by(() => {
            const _items = items.map((i:any) => i)
            let _i = _items.sort((a:any, b:any) => (a.datetime as string).localeCompare(b.datetime))

            const filteredItems = filterFunction(_i, filters)
            if (filteredItems.length > 0) {
                  _i = filteredItems
                  if (browser) document.documentElement.scroll({ top: 0, behavior: 'smooth' })
            }

            const mapped = _i.map((item:any) => {
                  const date = new Date(item.datetime)
                  const _date = new Date(date.valueOf() - 60 * 1000 * 60 * 6)

                  return {
                        ...item,
                        _date: {
                              date: date,
                              formattedDate: formatDate(date),
                              d: formatDate(_date),
                        },
                  }
            })

            const blocks = new Array()
            const indexes = new Map()
            mapped.forEach((i:any) => {
                  let index = indexes.get(i._date.d)
                  if (index === undefined) {
                        index = blocks.push({ _date: i._date.date, date: i._date.formattedDate, items: [] }) - 1
                        indexes.set(i._date.d, index)
                  }
                  blocks[index].items.push(i)
            })

            return blocks
      })

      async function scrollToView(this: HTMLElement, ev: Event) {
            if (!this) return
            ev.preventDefault()
            const time = this.getAttribute('href')
            if(!time) return
            const element = document.getElementById(time?.replace('#', ''))
            if (!element) return

            const { y } = element.getBoundingClientRect()
            document.documentElement.scroll({ top: document.documentElement.scrollTop + y, behavior: 'smooth' })
      }
</script>

<div bind:this={wrapper} class="w-full flex flex-col gap-16">
      {#each _items as block, i (i)}
            <div class="flex flex-col gap-4 relative">
                  <span id={block._date.valueOf()} class="absolute top-[-3rem]"></span>
                  <div class="filter-bar sticky w-max top-[3.2rem] z-[10] flex gap-2">
                        <FilterPill active={filterActive}>
                              {#snippet menuItems()}
                                    {#each filterValues as value, j (j)}
                                          <div class="capitalize border-b-[1px] last:border-b-0 border-[#00000011] w-full text-center">
                                                <BlockHeading class="capitalize my-1 select-none text-lg w-full">
                                                      <button data-filter-key={value.key} data-filter-value={value.value} onclick={setFilter} class="py-1 px-3 w-full">
                                                            {value.label}
                                                      </button>
                                                </BlockHeading>
                                          </div>
                                    {/each}
                                    {#if filterActive}
                                          <div class="capitalize border-b-[1px] last:border-b-0 border-[#00000011] w-full text-center">
                                                <div class="capitalize my-1 select-none text-[#00000099] text-lg w-full font-[300]">
                                                      <button data-filter-key="-1" data-filter-value="-1" onclick={resetFilter} class="w-full py-1 px-3"> {locale.ŧ({ default: 'zrušit', en: 'cancel' })} </button>
                                                </div>
                                          </div>
                                    {/if}
                              {/snippet}
                        </FilterPill>
                        <HeadingPill>
                              <span class="text-[#8f8f8f]">
                                    {locale.ŧ({ default: 'Den:', en: 'Day:' })}
                              </span>
                              {getLocaleDay(block._date, true, locale.locale)}
                              {formatDate(block._date)}
                              {#snippet menuItems()}
                                    {#each _items as time, j (j)}
                                          <div class="capitalize border-b-[1px] last:border-b-0 border-[#00000011] w-full text-center">
                                                <a onclick={scrollToView} href="#{time._date.valueOf()}" class="flex w-full py-1 px-3">
                                                      <BlockHeading class="capitalize my-1 select-none text-lg w-full">
                                                            {getLocaleDay(time._date, true, locale.locale)}
                                                            {formatDate(time._date)}
                                                      </BlockHeading>
                                                </a>
                                          </div>
                                    {/each}
                              {/snippet}
                        </HeadingPill>
                  </div>
                  <div class="program-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 w-full gap-4">
                        {#each block.items as item, j (j)}
                              <ProgramListItem {item}></ProgramListItem>
                        {/each}
                  </div>
            </div>
      {/each}
</div>

<style lang="postcss">
      .program-grid {
            @screen md {
                  /*grid-auto-rows: 1fr;*/
            }
      }
</style>
